import { ApiResponse } from 'apisauce';
import { Api } from './api';
import {
  CreateOrganizationRequest,
  CreateOrganizationResult,
  CreateOrganizationResponse,
  getGeneralApiProblem,
  UpdateOrgContactRequest,
  UpdateOrgContactResult,
  CreateFacilityRequest,
  CreateFacilityResult,
  CreateFacilityResponse,
  UpdateFacEcofitRequest,
  UpdateFacEcofitResult,
  CreateFacCCRequest,
  CreateFacCCResult,
  UpdateFacContactRequest,
  UpdateFacContactResult,
  DigitalProductsList,
  addDigitalProductsResult,
} from '../models';

export class AutomationApi extends Api {
  async createOrg(payload: CreateOrganizationRequest): Promise<CreateOrganizationResult> {
    const response: ApiResponse<CreateOrganizationResponse> = await Api.apisauce.post(
      `/automation/organization`,
      payload,
    );

    if (!response.ok) {
      const problem = getGeneralApiProblem(response);
      if (problem) return problem;
    }

    try {
      if (response.data) {
        return { kind: 'ok', data: response.data };
      }
      return { kind: 'bad-data' };
    } catch {
      return { kind: 'bad-data' };
    }
  }

  async updateOrgContact(
    orgId: number,
    payload: UpdateOrgContactRequest,
  ): Promise<UpdateOrgContactResult> {
    const response: ApiResponse<null> = await Api.apisauce.post(
      `/automation/organization/${orgId}/contacts`,
      payload,
    );

    if (!response.ok) {
      const problem = getGeneralApiProblem(response);
      if (problem) return problem;
    }

    return { kind: 'ok' };
  }

  async updateFacContact(
    facId: number,
    payload: UpdateFacContactRequest,
  ): Promise<UpdateFacContactResult> {
    const response: ApiResponse<null> = await Api.apisauce.post(
      `/automation/facility/${facId}/contacts`,
      payload,
    );

    if (!response.ok) {
      const problem = getGeneralApiProblem(response);
      if (problem) return problem;
    }

    return { kind: 'ok' };
  }

  async createFac(payload: CreateFacilityRequest): Promise<CreateFacilityResult> {
    const response: ApiResponse<CreateFacilityResponse> = await Api.apisauce.post(
      `/automation/facility`,
      payload,
    );

    if (!response.ok) {
      const problem = getGeneralApiProblem(response);
      if (problem) return problem;
    }

    try {
      if (response.data) {
        return { kind: 'ok', data: response.data };
      }
      return { kind: 'bad-data' };
    } catch {
      return { kind: 'bad-data' };
    }
  }

  async updateFacEcofit(
    facId: number,
    payload: UpdateFacEcofitRequest,
  ): Promise<UpdateFacEcofitResult> {
    const response: ApiResponse<null> = await Api.apisauce.post(
      `/automation/facility/${facId}/ecofit`,
      payload,
    );

    if (!response.ok) {
      const problem = getGeneralApiProblem(response);
      if (problem) return problem;
    }

    return { kind: 'ok' };
  }

  async createFacCC(payload: CreateFacCCRequest): Promise<CreateFacCCResult> {
    const response: ApiResponse<null> = await Api.apisauce.post(
      `/automation/console-config`,
      payload,
    );

    if (!response.ok) {
      const problem = getGeneralApiProblem(response);
      if (problem) return problem;
    }

    return { kind: 'ok' };
  }

  async addDigitalProducts(
    facId: number,
    payload: DigitalProductsList,
  ): Promise<addDigitalProductsResult> {
    const response: ApiResponse<null> = await Api.apisauce.post(
      `/automation/facility/${facId}/digital-products`,
      payload,
    );

    if (!response.ok) {
      const problem = getGeneralApiProblem(response);
      if (problem) return problem;
    }

    return { kind: 'ok' };
  }
}
